import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Slides from '@ifeng-fe/ui_pc_slides';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Event } from '@ifeng-fe/ui_base';
import { handleAd } from '@ifeng-fe/ui_pc_ad';

class BannerPic extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        // ad: PropTypes.object,
    };

    state = {
        data: this.props.content,
    };

    event = new Event();

    // insertArr 为广告方想要插入的一组位置，replaceArr 为广告方想要替换的一组位置，adFn 为回调方法
    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const { data } = this.state;

            const infoData = [...data];
            const refs = [];

            // 广告插入，在指定位置后插入广告位数据
            insertArr.forEach(item => {
                if (item >= 0 && item <= 4) {
                    const ref = React.createRef();
                    const ref1 = React.createRef();

                    refs.push({ index: item, ref, ref1 });

                    infoData.splice(item, 0, { type: 'ad', ref, ref1 });
                } else {
                    const ref = React.createRef();

                    refs.push({ index: item, ref });

                    infoData.splice(item, 0, { type: 'ad', ref });
                }
            });

            // 广告替换，在指定位置删除原数据，替换为广告位数据
            replaceArr.forEach(item => {
                if (item >= 0 && item <= 4) {
                    const ref = React.createRef();
                    const ref1 = React.createRef();

                    refs.push({ index: item, ref, ref1 });

                    infoData.splice(item, 1, { type: 'ad', ref, ref1 });
                } else {
                    const ref = React.createRef();

                    refs.push({ index: item, ref });

                    infoData.splice(item, 1, { type: 'ad', ref });
                }
            });

            // 广告数据整合处理完毕后，更新列表数据
            this.setState(
                {
                    data: infoData,
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        if (ref.ref1) {
                            dom[ref.index] = [ref.ref.current, ref.ref1.current];
                        } else {
                            dom[ref.index] = ref.ref.current;
                        }
                    }

                    try {
                        adFn(dom);
                    } catch (e) {
                        console.error(e);

                        this.setState({
                            data,
                        });
                    }
                },
            );
        }

        return;
    };

    async componentDidMount() {
        // 插入软广
        // try {
        //     const { ad } = this.props;

        //     const callback = await handleAd(ad);

        //     callback(ad.data, this.event, this.insert); // 将自定义广告插入方法传入，这样广告方即可调用
        // } catch (e) {
        //     console.error(e);
        // }

        // try {
        //     this.event.trigger('init'); // 触发广告位插入方法
        // } catch (e) {
        //     console.error(e);
        // }
    }

    sliderTmpl = (item, isClone) => {
        if (item.type === 'web' && item.title.includes('http')) {
            return (
                <div>
                    <a href={item.url} target="_blank" rel="noreferrer">
                        <iframe
                            scrolling="no"
                            frameBorder="0"
                            style={{ border: '0', width: '475px', height: '368px' }}
                            border="0"
                            src={item.title}
                        />
                    </a>
                </div>
            );
        }

        return item.type === 'ad' ? (
            <div ref={isClone ? item.ref1 : item.ref} />
        ) : (
            <div>
                <a href={item.url} className={styles.pic_img} target="_blank" rel="noreferrer">
                    <img src={item.thumbnail} width="475" height="368" className={styles.trans} />
                </a>
                <div className={styles.text} />
                <p className={styles.title}>
                    <a href={item.url} target="_blank" rel="noreferrer">
                        {item.title}
                    </a>
                </p>
            </div>
        );
    };

    /**
     * 渲染组件
     */
    render() {
        const { data } = this.state;

        const config = {
            autoplay: false,
            infinite: false,
            direction: 'forward',
            axis: 'horizonta',
            sliderTmpl: this.sliderTmpl,
            dotCurrentStyle: styles.current,
        };

        return (
            <>
                <div className={styles.videoSlideTitle}>
                    {data?.[0]?.title && data[0].title.includes('http') ?
                        <a href="http://finance.ifeng.com/money/special/mjmrt/" target="_blank" rel="noreferrer">视频解盘</a> :
                        <a href="javascript:;">焦点图</a>
                    }
                </div>
                <div className={styles.bannerPic}>
                    <Slides content={data} config={config} />
                </div>
            </>
        );
    }
}

export default errorBoundary(BannerPic);
